import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';

import { useState } from 'react';
import Checkbox from 'components/Checkbox';
import { AlertCircle, ShieldCheckmarkOutline } from 'react-ionicons';
import Divider from 'components/Divider';

interface ReviewRebillModalProps {
  isOpen: boolean;
  close: () => void;
  onConfirm?: () => void;
}

const ReviewRebillModal = ({
  isOpen,
  close,
  onConfirm,
}: ReviewRebillModalProps) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
  };

  return (
    <Modal
      isVisible={isOpen}
      close={close}
      className="!max-h-full !w-[624px] justify-between sm:!max-h-[90vh]"
      scrollableClassName="min-h-full"
      enableScrolling
    >
      <div className="flex flex-col gap-2 rounded-t-lg bg-background-base-surface-3 px-8 py-6 font-bold leading-9">
        <h1 className="text-xl text-content-base-default lg:text-2xl">
          Review & finalize
        </h1>
        <h1 className="text-base text-content-base-subdued">
          Request is expected to be completed within 45–60 business days.
        </h1>
      </div>
      <div className="flex flex-col gap-8 p-8">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col items-start gap-2 self-stretch rounded bg-background-base-surface-0 p-4 font-bold">
            <div className="flex w-full grow flex-row justify-between  text-sm">
              <div className="flex text-sm">Rebill consolidation service </div>
              <div className="text-content-base-default">$34.98</div>
            </div>
            <div className="self-stretch">
              <Divider layout="horizontal" variant="subdued" className="my-2" />
            </div>
            <div className="flex w-full grow flex-row justify-between">
              <div className="flex self-center text-base">Total due</div>
              <div className="text-2xl text-content-accent-default">$34.98</div>
            </div>
          </div>
          <div className="flex content-center items-center gap-2 self-stretch">
            <ShieldCheckmarkOutline
              color="#94A3B8"
              width="16px"
              height="16px"
            />
            <p className="text-xs font-bold text-content-base-subdued">
              Continue paying your current bill to avoid risk of disconnection
              during the transition.
            </p>
          </div>
        </div>
        <div className="flex flex-col content-center items-center rounded bg-background-base-surface-3 p-4">
          <div className="flex content-center items-center gap-4 self-stretch ">
            <div className="flex w-full flex-col items-start gap-2">
              <div className="flex content-center items-center gap-1 self-stretch">
                <AlertCircle color="#F8FAFC" width="16px" height="16px" />
                <p className="text-sm font-bold text-content-base-default">
                  Requirement
                </p>
              </div>
              <p className="text-sm font-bold text-content-base-subdued">
                Letter of agreement is missing
              </p>
            </div>
            <GraniteButton
              size="medium"
              variant="secondary"
              onClick={onConfirm}
              className="w-1/4"
            >
              Add LOA
            </GraniteButton>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-base font-bold text-content-base-subdued">
            By clicking the following, you are confirming that you have read,
            understood, and agree to{' '}
            <a
              href={`https://www.granitenet.com/Content/pdfs/Granite%20Website%20-%20General%20Terms%20and%20Conditions%20of%20Service%20(May%2023,%202022)%20(00053066xD85FF).pdf`}
              target="_blank"
              rel="noreferrer"
              download
              className="cursor-pointer text-content-accent-default underline visited:text-content-accent-default"
            >
              {"Granite's"} Terms & Conditions.
            </a>
          </p>
          <Checkbox
            label="I agree to Granite’s Terms & Conditions"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
        </div>

        <div className="flex items-start gap-4">
          <GraniteButton
            size="large"
            onClick={close}
            variant="secondary"
            type="button"
          >
            Cancel
          </GraniteButton>
          <GraniteButton
            size="large"
            variant="primary"
            type="submit"
            disabled={!isChecked}
            onClick={onConfirm}
          >
            Agree & submit
          </GraniteButton>
        </div>
      </div>
    </Modal>
  );
};

export default ReviewRebillModal;
